import { csrfTokenHeader } from "@circle-react/helpers/csrfToken";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { AwsS3UploadParameters } from "@uppy/aws-s3";
import { isFunction } from "lodash";

const headers = {
  accept: "application/json",
  "content-type": "application/json",
};

export const signedUploadUrlRequest = async (
  file: File,
  setUploadError: () => void,
): Promise<AwsS3UploadParameters> => {
  try {
    const response = await fetch(internalApi.voiceMessages.signedUploadUrl(), {
      method: "POST",
      headers: { ...headers, ...csrfTokenHeader() },
      body: JSON.stringify({
        filename: file.name,
        contentType: file.type,
      }),
    });

    const data = await response.json();
    return {
      method: data.method,
      url: data.url,
      fields: data.fields,
      headers: {
        "Content-Type": file.type,
      },
    };
  } catch (error) {
    setUploadError();
    console.error("Error uploading audio file:", error);
    throw error;
  }
};

export const processFileRequest = async (
  objectId: string,
  recordingId: string,
  setServerError?: () => void,
): Promise<void> => {
  try {
    await fetch(internalApi.voiceMessages.processFileUrl(), {
      method: "POST",
      headers: { ...headers, ...csrfTokenHeader() },
      body: JSON.stringify({
        object_id: objectId,
        recording_id: recordingId,
      }),
    });
  } catch (error) {
    isFunction(setServerError) && setServerError();
    console.error("Error processing audio file:", error);
  }
};
